export const debounce = (func, delay = 300) => {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
};

export const normalizeUrl = (url) => {
    if (!url) return '';

    // Trim whitespace
    url = url.trim();

    // Return empty string if url is just whitespace
    if (url === '') return '';

    // Remove multiple slashes after protocol
    url = url.replace(/(https?:\/\/)\/+/g, '$1');

    // Check for protocol and add if missing
    if (!url.match(/^https?:\/\//i)) {
        return "https://" + url.replace(/^\/+/, '');
    }

    return url;
};


export const isValidUrl = (url) => {
    if (!url) return false;
    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
    return urlPattern.test(url.trim());
};


export const checkUrl = (draft_refcode, url, keyword = null, callbacks = {}) => {
    const { ok, invalid, fail, done } = callbacks;
    app.lucep_ai
        .check_url_content(draft_refcode, url, keyword)
        .then((data) => {
            if (data.content) {
                if (typeof ok === "function") {
                    ok(data.urlref);
                }
            } else {
                if (typeof invalid === "function") {
                    invalid();
                }
            }
        })
        .catch((err) => {
            if (typeof fail === "function") {
                fail(err);
            }
        })
        .finally(() => {
            if (typeof done === "function") {
                done();
            }
        });
};

export function isPublicURL(input) {
    try {
        const parsed = new URL(input);

        // Must use HTTP or HTTPS
        if (!/^https?:$/.test(parsed.protocol)) return false;

        // Reject localhost
        if (parsed.hostname === "localhost") return false;

        // Reject private IPs
        const ip = parsed.hostname;
        const privatePatterns = [
            /^10\./,
            /^127\./,
            /^192\.168\./,
            /^172\.(1[6-9]|2[0-9]|3[0-1])\./
        ];
        if (privatePatterns.some(rx => rx.test(ip))) return false;

        // Check if the hostname ends with a valid TLD
        if (!/\.[a-z]{2,}$/i.test(parsed.hostname)) return false;

        return true;
    } catch {
        return false;
    }
}